import { render, staticRenderFns } from "./healthDeviceHome.vue?vue&type=template&id=19a421d0&scoped=true"
import script from "./healthDeviceHome.vue?vue&type=script&lang=js"
export * from "./healthDeviceHome.vue?vue&type=script&lang=js"
import style0 from "./healthDeviceHome.vue?vue&type=style&index=0&id=19a421d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a421d0",
  null
  
)

export default component.exports